import React from 'react';
import { BiLoaderAlt } from 'react-icons/bi';

import './Loading.css';

function Loading() {
  return <BiLoaderAlt className="loading" />;
}

export default Loading;
